import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Content, Header, OpenContent } from './components';
import { CollapsibleContext } from './Collapsible.context';
/**
 * Collapsible component used mainly on filters and other components that need to be collapsible.
 */
export const Collapsible = (props) => {
    return (_jsx(CollapsibleContext.Provider, { value: props, children: _jsxs(Container, { children: [_jsx(Header, {}), _jsx(Content, {}), _jsx(OpenContent, {})] }) }));
};
